<template>
  <v-card class="card-border">
    <v-card-text>
      <v-form>
        <v-row dense align="center">
          <v-col cols="12" sm="12" md="3">
            <DateMenu label="Data Inicio" @onChanged="dateStart = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <DateMenu label="Data Fim" @onChanged="dateEnd = $event" />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Supervisor, Vendedor } from "@/services/dashboard";

export default {
  name: "Filtro",

  components: {
    DateMenu: () => import("@/components/datepicker/DateMenu")
  },

  data() {
    return {
      dateStart: null,
      dateEnd: null,
      serviceSupervisor: new Supervisor(),
      serviceVendedor: new Vendedor()
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"]),
    ...mapGetters("dashboard", ["getLeads"]),
    ...mapGetters("dashboard", ["getDesempenho"]),
    ...mapGetters("dashboard", ["getRankLeads"]),
    ...mapGetters("dashboard", ["getRankNovos"]),
    ...mapGetters("dashboard", ["getRankUsados"]),
    ...mapGetters("dashboard", ["getRankConsorcio"]),
    ...mapGetters("dashboard", ["getHistoricoRank"])
  },

  methods: {
    ...mapActions("dashboard", ["setLeads"]),
    ...mapActions("dashboard", ["setDesempenho"]),
    ...mapActions("dashboard", ["setRankLeads"]),
    ...mapActions("dashboard", ["setRankNovos"]),
    ...mapActions("dashboard", ["setRankUsados"]),
    ...mapActions("dashboard", ["setRankConsorcio"]),
    ...mapActions("dashboard", ["setHistoricoRank"]),

    async getLeadsByDateRange() {
      try {
        const leads = await this.serviceVendedor.getLeadsByDateRange(
          this.dateStart,
          this.dateEnd,
          this.getUser.cpf
        );
        this.setLeads(leads);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getDesempenhoByMonth() {
      try {
        const desempenho = await this.serviceVendedor.getDesempenhoByMonth(
          this.getUser.cpf,
          this.getUser.empresaPrincipal
        );
        this.setDesempenho(desempenho);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getHistoricoRanks() {
      try {
        const rank = await this.serviceVendedor.getHistoricoRanks(
          this.getUser.cpf
        );
        this.setHistoricoRank([...rank]);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getRanks() {
      try {
        const rank = await this.serviceSupervisor.getRanks();
        this.setRankLeads([...rank]);
        this.setRankNovos([...rank]);
        this.setRankUsados([...rank]);
        this.setRankConsorcio([...rank]);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async buscar() {
      try {
        await this.getLeadsByDateRange();
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao carregar Dados");
        return Promise.reject(error);
      }
    }
  },

  async mounted() {
    try {
      if (this.getLeads.length == 0) {
        await this.getLeadsByDateRange();
      }
      if (this.getDesempenho.length == 0) {
        await this.getDesempenhoByMonth();
      }
      if (
        this.getRankUsados.length == 0 ||
        this.getRankNovos.length == 0 ||
        this.getRankLeads.length == 0 ||
        this.getRankConsorcio.length == 0
      ) {
        await this.getRanks();
      }
      if (this.getHistoricoRank.length == 0) {
        await this.getHistoricoRanks();
      }
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};
</script>
